import { gql } from "@apollo/client";

export const AssignNewScheduleTaskBulkMutation= gql`
mutation($input: [ScheduleAssignedTaskInput!]!){
  AssignNewScheduleTaskBulk(input: $input) {
    message
    response
  }
}
`;